// Node
import { times } from 'underscore';


export default class CampListLoading extends React.Component {
  constructor(props) {
    super(props);
    this.card_loading = this.card_loading.bind(this);
  }

  shouldComponentUpdate() {
    return false;
  }

  card_loading(index) {
    return (
      <div className='card card_big card-preload'
           key={index}
      >
        <div className='card-preload__thumb preload__thumb card-loader card-loader--tabs'></div>
        <div className='card-preload__desc'>
          <div className='preload__name card-loader card-loader--tabs'></div>
          <div className='preload__line preload__line_w100pr preload__line_mb35 card-loader card-loader--tabs'></div>
          <div className='preload__line preload__line_w80pr card-loader card-loader--tabs'></div>
          <div className='preload__line preload__line_w80pr card-loader card-loader--tabs'></div>
          <div className='preload__line preload__line_w80pr card-loader card-loader--tabs'></div>
        </div>
        <div className='card-preload__price'>
          <div className='preload__price card-loader card-loader--tabs'></div>
          <div className='preload__line preload__line_w60pr preload__line_h14px preload__line_mb16 preload__line_ml-auto card-loader card-loader--tabs'></div>
          <div className='preload__line preload__line_w100pr preload__line_h19px preload__line_mb10 card-loader card-loader--tabs'></div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className='cards'>
        {times(this.props.camps_count, this.card_loading)}
      </div>
    );
  }
}
